<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="title1">VAGABOND</p>
<p class="title2">Gerald Seymour</p>
<p class="logo">Thomas Dunne Books</p>
<p class="center">St. Martin’s Press <img alt="" class="inline" src="OEBPS/images/logo.jpg"/> New York</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?545fa8e8